import { Route, Routes } from 'react-router-dom';
import { Complete } from './pages/Complete';
import { Intro } from './pages/Intro';
import { Quizz } from './pages/Quizz';

import questionMarkImage from './assets/interrogacao.jpg';

export const App = () => {
    return (
        <div className="container">
            <img className="question-mark top" src={questionMarkImage} alt="Decoração" />

            <Routes>
                <Route path="/" element={<Intro />} />
                <Route path="/quizz" element={<Quizz />} />
                <Route path="/complete" element={<Complete />} />
            </Routes>

            <img className="question-mark bottom" src={questionMarkImage} alt="Decoração" />
        </div>
    );
}